import * as Yup from "yup";

export const formValidationSchema = Yup.object().shape({
  jenis_checklist: Yup.string().required("Pilih jenis checklist"),
  nama_item_checklist: Yup.string().required("Masukan nama item checklist"),
  keterangan: Yup.string().required("Masukkan keterangan"),
});
